import { render } from "./svg-like.vue?vue&type=template&id=8cef8950"
import script from "./svg-like.vue?vue&type=script&lang=ts"
export * from "./svg-like.vue?vue&type=script&lang=ts"
script.render = render

export default script